module.exports = __webpack_public_path__ + "static/media/chat-dark.10905c4a.svg";